import React from 'react';
import { Grid, Button, SmallBodyText, GridItem } from 'ui-toolkit';
import styled from 'styled-components';
import { IHasTestData } from '../../../test-utilities/IHasTestData';
import { mergeTests } from '../../../test-utilities/mergeTests';

const StyledNumber = styled.span`
  font-weight: bold;
`;

const ButtonContainerStyles = styled(GridItem)`
  > * {
    &:first-child {
      margin-right: ${(props) => props.theme.spacing.spacing3};
    }
  }
`;

const ButtonStyled = styled(Button)`
  border: none;
`;

const StyledGrid = styled(Grid)`
  padding: 0 ${(props) => props.theme.spacing.spacing5};
`;

interface IPagerProps extends IHasTestData {
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (newPage: number) => void;
  onPageSizeChange: (newPage: number) => void;
  disabled?: boolean;
}
export const Pager: React.FC<IPagerProps> = ({
  total,
  page,
  pageSize = 20,
  onPageChange,
  onPageSizeChange,
  disabled,
  'data-test-id': dataTestId,
  'data-test-class': dataTestClass,
}) => {
  const numberOfPages = Math.ceil(total / pageSize) || 1;
  const maxOrderForCurrentPage = page * pageSize + pageSize;

  return (
    <StyledGrid
      textAlign={'center'}
      alignItems={'center'}
      templateColumns={'max-content 1fr'}
      data-test-class={dataTestClass}
      data-test-id={dataTestId}
    >
      <SmallBodyText>
        Showing <StyledNumber>{page * pageSize + 1}</StyledNumber> to{' '}
        <StyledNumber>{maxOrderForCurrentPage > total ? total : maxOrderForCurrentPage}</StyledNumber> of{' '}
        <StyledNumber>{total}</StyledNumber> results
      </SmallBodyText>
      <ButtonContainerStyles justifySelf="end">
        <ButtonStyled
          intent={'secondary'}
          disabled={page === 0 || disabled}
          onClick={() => onPageChange(page - 1)}
          data-test-class={dataTestClass}
          data-test-id={mergeTests(dataTestId, 'prev')}
        >
          Previous
        </ButtonStyled>
        <ButtonStyled
          intent={'secondary'}
          disabled={page + 1 === numberOfPages || disabled}
          onClick={() => onPageChange(page + 1)}
          data-test-class={dataTestClass}
          data-test-id={mergeTests(dataTestId, 'next')}
        >
          Next
        </ButtonStyled>
      </ButtonContainerStyles>
    </StyledGrid>
  );
};
